export default {
  author: {
    authorProfile: 'About the author',
    by: 'By',
    on: 'on'
  }
}
